export type SortDir = 'asc' | 'desc';

/** A sortable table header cell: real <th> with aria-sort, an in-cell button so
 *  it's keyboard-operable, and a direction indicator. */
export function SortHeader<K extends string>({
  label,
  sortKey,
  activeKey,
  direction,
  onSort,
  numeric,
}: {
  label: string;
  sortKey: K;
  activeKey: K;
  direction: SortDir;
  onSort: (k: K) => void;
  numeric?: boolean;
}) {
  const active = activeKey === sortKey;
  const ariaSort: 'ascending' | 'descending' | 'none' = active
    ? direction === 'asc'
      ? 'ascending'
      : 'descending'
    : 'none';
  return (
    <th scope="col" aria-sort={ariaSort} className={numeric ? 'col-num' : undefined}>
      <button type="button" className="sort-btn" onClick={() => onSort(sortKey)}>
        <span>{label}</span>
        <span aria-hidden="true" className="sort-ind">
          {active ? (direction === 'asc' ? '▲' : '▼') : '↕'}
        </span>
      </button>
    </th>
  );
}
